import React from 'react'
import DataView from 'EurestoComponents/DataForm'
import Constants from 'EurestoFonction/Constants'

export default () => {
  return (
    <DataView module={Constants.module.CONFIGURATION} object={Constants.donnee.template_type} />
  )
}



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Restaurant/Message/index.js